import React, { useState, useEffect } from 'react';
import { HeaderNav } from '../components/partials/HeaderNav';
import { Footer } from '../components/partials/Footer';
import { Productsv2 } from '../components/shared/productsv2';
import SEO from '../components/SEO';
import { useSelector } from "react-redux";

export default props => {
    const account = useSelector((state) => state.account);
    const { brand } = account;

    const [view, setView] = useState('list');

    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    const query = new URLSearchParams(props.location.search);
    const name = query.get('name') || "";

    // Reset pagination when search query changes
    useEffect(() => {
        setCurrentPage(1);
    }, [name]);

    return (
        <>
            <SEO 
                title={name ? `Search: ${name} | Premier Pharmaceuticals` : "Search Products | Premier Pharmaceuticals"}
                description={name ? `Search results for "${name}" in our pharmaceutical catalog` : "Search our extensive pharmaceutical catalog for specific products"}
                keywords={`search pharmaceuticals, find medicine, ${name || 'product search'}, pharmacy search`}
                url={`https://app.premierpharma.com/search${name ? `?name=${encodeURIComponent(name)}` : ''}`}
            />
            <HeaderNav />
            <div className="search-page">
                <div className="container-fluid">
                    <Productsv2
                        brand={brand}
                        page="search"
                        view={view}
                        setView={setView}
                        name={name}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            </div>
            <Footer />
        </>
    )
}
